import React, { useState } from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const copyToClipboard = async (text) => {
  if (!text) return;

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "absolute";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);
};

export default function CopyableText({ value, displayValue, className = "" }) {
  const [copied, setCopied] = useState(false);
  const [hovered, setHovered] = useState(false);
  const rawValue = value == null ? "" : String(value);
  const textToShow = displayValue ?? rawValue;

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!rawValue) return;
    await copyToClipboard(rawValue);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200);
  };

  if (!rawValue) {
    return <span className={className}>None</span>;
  }

  return (
    <span className={`d-inline-flex align-items-center gap-1 ${className}`}>
      <span>{textToShow}</span>
      <Tooltip title={copied ? "Copied" : "Copy"}>
        <button
          type="button"
          onClick={handleCopy}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          className="border-0 d-inline-flex align-items-center justify-content-center"
          aria-label="Copy value"
          style={{
            width: 24,
            height: 24,
            borderRadius: "999px",
            backgroundColor: copied
              ? "#d1fae5"
              : hovered
              ? "#dbeafe"
              : "#e9ecef",
            color: copied ? "#0f5132" : hovered ? "#1d4ed8" : "#495057",
            cursor: "pointer",
            transition: "all 0.2s ease",
          }}
        >
          <FontAwesomeIcon icon="copy" style={{ fontSize: "0.9rem" }} />
        </button>
      </Tooltip>
    </span>
  );
}
